var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "createPosition",
          staticClass: "mod-form",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c(
            "h3",
            {
              staticClass: "modal-title",
              staticStyle: { color: "#9A9A9A !important" }
            },
            [_vm._v("\n      CREATE POSITION\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: { "error-input": _vm.$v.data_position.name.$error }
                    },
                    [
                      _c("label", [_vm._v("Position Name*")]),
                      _vm._v(" "),
                      _c("j-input", {
                        attrs: {
                          "max-length": 255,
                          placeholder: "Position Name"
                        },
                        model: {
                          value: _vm.$v.data_position.name.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.data_position.name, "$model", $$v)
                          },
                          expression: "$v.data_position.name.$model"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: { "error-input": _vm.$v.data_position.code.$error }
                    },
                    [
                      _c("label", [_vm._v("Position Code*")]),
                      _vm._v(" "),
                      _c("j-input", {
                        attrs: { "max-length": 255, placeholder: "Code" },
                        model: {
                          value: _vm.$v.data_position.code.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.data_position.code, "$model", $$v)
                          },
                          expression: "$v.data_position.code.$model"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input": _vm.$v.data_position.parent.$error
                      }
                    },
                    [
                      _c("label", [_vm._v("Parent")]),
                      _vm._v(" "),
                      _vm.defaultParentLoaded
                        ? _c("j-single-select", {
                            attrs: {
                              "is-async": true,
                              "load-options": _vm.loadOptionsParent,
                              "default-options": _vm.defaultParent,
                              placeholder: "Select Parent",
                              "value-format": "object",
                              label: "name",
                              "search-prompt-text":
                                "Type minimum 3 characters to search..."
                            },
                            model: {
                              value: _vm.$v.data_position.parent.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_position.parent,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.data_position.parent.$model"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input": _vm.$v.data_position.divisions.$error
                      }
                    },
                    [
                      _c("label", [_vm._v("Unit")]),
                      _vm._v(" "),
                      _vm.defaultUnitLoaded
                        ? _c("j-single-select", {
                            attrs: {
                              "is-async": true,
                              "load-options": _vm.loadOptionsDivisions,
                              "default-options": _vm.defaultUnit,
                              "value-format": "object",
                              placeholder: "Select Unit",
                              label: "name",
                              "search-prompt-text":
                                "Type minimum 3 characters to search..."
                            },
                            model: {
                              value: _vm.$v.data_position.divisions.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_position.divisions,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.data_position.divisions.$model"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input": _vm.$v.data_position.layer.$error
                      }
                    },
                    [
                      _c("label", [_vm._v("Layer")]),
                      _vm._v(" "),
                      _vm.defaultLayerLoaded
                        ? _c("j-single-select", {
                            attrs: {
                              "is-async": true,
                              "load-options": _vm.loadOptionsLayer,
                              "default-options": _vm.defaultLayer,
                              "value-format": "object",
                              placeholder: "Select Layer",
                              label: "name",
                              "search-prompt-text":
                                "Type minimum 3 characters to search..."
                            },
                            model: {
                              value: _vm.$v.data_position.layer.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_position.layer,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.data_position.layer.$model"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue m__r--5",
                        on: { click: _vm.saveCreatePosition }
                      },
                      [_vm._v("\n            Create\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      { staticClass: "btn gray", on: { click: _vm.closePage } },
                      [_vm._v("\n            Close\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15bc8f43", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15bc8f43","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/position/jPositionCreate.vue
// module id = null
// module chunks = 